import { Outlet } from "react-router-dom";

const NotificationRoutes = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default NotificationRoutes;
